import none from '../../img/leoLogo.png'
import majontorsh from '../../img/smooti/majontorsh.jpg'

export const smooti=[
    {
      "id": "111",
      "title": "پیناکولادا",
      "desciption": "آب آناناس-سیروپ نارگیل-شیر-خامه-یخ",
      "price": "199",
      "image": none
    },
    {
      "id": "112",
      "title": "معجون ترش",
      "desciption": "تمرهندی-زغال اخته-لواشک-آب آلبالو-لیمو",
      "price": "210",
      "image": majontorsh
    },
    {
      "id": "113",
      "title": "اسموتی ویکتوریا",
      "desciption": "هلو-انبه-آناناس-یخ",
      "price": "210",
      "image": none
    },
    {
      "id": "114",
      "title": "اسموتی انجل",
      "desciption": "هلو-انبه-پرتقال-یخ",
      "price": "210",
      "image": none
    },
    {
      "id": "115",
      "title": "اسموتی زغال اخته",
      "desciption": "",
      "price": "199",
      "image": none
    },
    {
      "id": "116",
      "title": "اسموتی چری بری",
      "desciption": "آب آلبالو-توت فرنگی-آلبالو-یخ",
      "price": "210",
      "image": none
    }
  ]